import { createPipelineUrlFilterCodec } from '../../common/utils/url';
import type { InvestmentPipelineBoardFilters, InvestmentPipelineUrlFilters } from '../types';

const investmentPipelineUrlCodec = createPipelineUrlFilterCodec<InvestmentPipelineUrlFilters>({
  arrayKeys: {
    introducerUserIds: 'introducers',
    investorUserIds: 'investors',
    fundIds: 'funds',
    introductionTypes: 'types',
    timerStatuses: 'timers',
    stages: 'stages',
  },
  booleanKeys: {
    activeOnly: 'activeOnly',
    includeNoIntroducer: 'includeNoIntroducer',
  },
  stringKeys: {
    search: 'search',
    sort: 'sort',
    card: 'card',
  },
  activeStringKeys: ['search'],
});

export const encodeInvestmentPipelineUrlFilters = investmentPipelineUrlCodec.encode;
export const decodeInvestmentPipelineUrlFilters = investmentPipelineUrlCodec.decode;
export const getInvestmentPipelineActiveFilterCount =
  investmentPipelineUrlCodec.getActiveFilterCount;
export const investmentPipelineUrlKeys = investmentPipelineUrlCodec.ownedKeys;

export const toInvestmentPipelineBoardFilters = (
  filters: InvestmentPipelineUrlFilters,
): InvestmentPipelineBoardFilters => ({
  search: filters.search,
  activeOnly: filters.activeOnly ?? false,
  stages: filters.stages ?? [],
  investorUserIds: filters.investorUserIds ?? [],
  introducerUserIds: filters.introducerUserIds ?? [],
  includeNoIntroducer: filters.includeNoIntroducer,
  fundIds: filters.fundIds ?? [],
  introductionTypes: filters.introductionTypes ?? [],
  timerStatuses: filters.timerStatuses ?? [],
});
